/* eslint react/forbid-prop-types: 0 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import {
  Form,
  FormGroup,
  Col,
  ControlLabel,
  FormControl
} from "react-bootstrap";
import Client from "../Client";
import LocationSelect from "./fields/LocationSelect";
import { DEFAULT_JOB } from "../types";

const CustomSelect = ({ options, value, onChange }) => (
  <Select
    className="job-type-select"
    clearable={false}
    options={options}
    searchable={false}
    value={value}
    onChange={onChange}
  />
);
CustomSelect.propTypes = {
  options: PropTypes.array,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired
};
CustomSelect.defaultProps = {
  options: [],
  value: ""
};

class JobForm extends Component {
  state = {
    locations: []
  };

  // loading spinner/ui improvement to be gained here
  // essentially an 'editing' location concern
  componentDidMount() {
    if (this.props.job.stop.location.id) {
      const locationType = this.props.job.stop.location.type.code;
      if (locationType === "JOB" || locationType === "CUSTOM") {
        return;
      }
      Client.getLocationsByType(locationType).then(locations => {
        this.setState({ locations });
      });
    }
  }

  handleChange = event => {
    const { updateJob } = this.props;
    const values = { [event.target.name]: event.target.value };

    updateJob(values);
  };

  handleLocationTypeChange = event => {
    const locationType = event.value;
    const { updateJobLocationType } = this.props;
    if (
      locationType !== "" &&
      locationType !== "CUSTOM" &&
      locationType !== "JOB"
    ) {
      Client.getLocationsByType(locationType).then(locations =>
        this.setState({ locations })
      );
    }
    updateJobLocationType(locationType);
  };

  handleLocationChange = location => {
    this.props.updateJob({ stop: { location: { ...location } } });
  };

  handleJobTypeChange = selectedOption => {
    this.props.updateJob({ type: selectedOption.value });
  };

  render() {
    const { job, errors } = this.props;
    const { locations } = this.state;

    const jobTypeOptions = [
      { value: "PICKUP", label: "Pickup" },
      { value: "DELIVERY", label: "Delivery" }
    ];

    const customerNameValidationState = errors.includes("customerName")
      ? "error"
      : null;

    const typeValidationState = errors.includes("type") ? "error" : null;

    return (
      <Form horizontal>
        <FormGroup
          controlId="customerName"
          validationState={customerNameValidationState}
        >
          <Col componentClass={ControlLabel} sm={3}>
            Name
          </Col>
          <Col sm={9}>
            <FormControl
              type="text"
              name="customerName"
              value={job.customerName}
              placeholder="Name"
              onChange={this.handleChange}
            />
          </Col>
        </FormGroup>

        <LocationSelect
          location={job.stop.location}
          locations={locations}
          errors={errors}
          handleLocationTypeChange={this.handleLocationTypeChange}
          handleLocationChange={this.handleLocationChange}
        />

        <FormGroup controlId="type" validationState={typeValidationState}>
          <Col componentClass={ControlLabel} sm={3}>
            Job Type
          </Col>
          <Col sm={9}>
            <FormControl
              componentClass={CustomSelect}
              options={jobTypeOptions}
              value={job.type}
              onChange={this.handleJobTypeChange}
            />
          </Col>
        </FormGroup>

        <FormGroup controlId="notes">
          <Col componentClass={ControlLabel} sm={3}>
            Notes
          </Col>
          <Col sm={9}>
            <FormControl
              componentClass="textarea"
              name="notes"
              value={job.notes}
              placeholder="Job Notes"
              onChange={this.handleChange}
            />
          </Col>
        </FormGroup>
      </Form>
    );
  }
}
JobForm.propTypes = {
  job: PropTypes.shape({
    externalId: PropTypes.string,
    stop: PropTypes.shape({
      location: PropTypes.shape({
        id: PropTypes.number,
        type: PropTypes.shape({
          code: PropTypes.string
        })
      })
    })
  }),
  updateJob: PropTypes.func.isRequired,
  errors: PropTypes.array,
  updateJobLocationType: PropTypes.func.isRequired
};
JobForm.defaultProps = {
  job: DEFAULT_JOB,
  errors: []
};

export default JobForm;



// WEBPACK FOOTER //
// ./src/forms/JobForm.js